const a = {
  addToFolder: () => import("./index30.mjs"),
  addedtoFolder: () => import("./index31.mjs"),
  alarmBell: () => import("./index32.mjs"),
  alignBottom: () => import("./index33.mjs"),
  alignCenter: () => import("./index34.mjs"),
  alignLeft: () => import("./index35.mjs"),
  alignMiddle: () => import("./index36.mjs"),
  alignRight: () => import("./index37.mjs"),
  alignTop: () => import("./index38.mjs"),
  amex: () => import("./index39.mjs"),
  applePay: () => import("./index40.mjs"),
  arrowBack: () => import("./index41.mjs"),
  arrowCursorBlue: () => import("./index42.mjs"),
  arrowCursorPink: () => import("./index43.mjs"),
  arrowCursorYellow: () => import("./index44.mjs"),
  arrowDown: () => import("./index45.mjs"),
  arrowRight: () => import("./index46.mjs"),
  arrowUp: () => import("./index47.mjs"),
  attachment: () => import("./index48.mjs"),
  audioModified: () => import("./index49.mjs"),
  blankCalendarBlue: () => import("./index50.mjs"),
  blankCalendarPink: () => import("./index51.mjs"),
  blankCalendarYellow: () => import("./index52.mjs"),
  brain: () => import("./index53.mjs"),
  businessStartupBlue: () => import("./index54.mjs"),
  businessStartupPink: () => import("./index55.mjs"),
  businessStartupYellow: () => import("./index56.mjs"),
  calendar: () => import("./index57.mjs"),
  cameraBlue: () => import("./index58.mjs"),
  cameraPink: () => import("./index59.mjs"),
  cameraYellow: () => import("./index60.mjs"),
  cameraVideoBlue: () => import("./index61.mjs"),
  cameraVideoPink: () => import("./index62.mjs"),
  cameraVideoYellow: () => import("./index63.mjs"),
  chatBubbleTypingOvalBlue: () => import("./index64.mjs"),
  chatBubbleTypingOvalPink: () => import("./index65.mjs"),
  chatBubbleTypingOvalYellow: () => import("./index66.mjs"),
  chatTwoBubblesSquareBlue: () => import("./index67.mjs"),
  chatTwoBubblesSquarePink: () => import("./index68.mjs"),
  chatTwoBubblesSquareYellow: () => import("./index69.mjs"),
  check: () => import("./index70.mjs"),
  checkCircle: () => import("./index71.mjs"),
  chevronDown: () => import("./index72.mjs"),
  chevronLeft: () => import("./index73.mjs"),
  chevronRight: () => import("./index74.mjs"),
  chevronUp: () => import("./index75.mjs"),
  circleClockBlue: () => import("./index76.mjs"),
  circleClockPink: () => import("./index77.mjs"),
  circleClockYellow: () => import("./index78.mjs"),
  close: () => import("./index79.mjs"),
  cog: () => import("./index80.mjs"),
  compass: () => import("./index81.mjs"),
  controlsForward: () => import("./index82.mjs"),
  controlsPause: () => import("./index83.mjs"),
  controlsPlay: () => import("./index84.mjs"),
  controlsRecord: () => import("./index85.mjs"),
  controlsRewind: () => import("./index86.mjs"),
  controlsStop: () => import("./index87.mjs"),
  dashboardGaugeBlue: () => import("./index88.mjs"),
  dashboardGaugePink: () => import("./index89.mjs"),
  dashboardGaugeYellow: () => import("./index90.mjs"),
  dinersClub: () => import("./index91.mjs"),
  discover: () => import("./index92.mjs"),
  downloadBottom: () => import("./index93.mjs"),
  downloadSquareBlue: () => import("./index94.mjs"),
  downloadSquarePink: () => import("./index95.mjs"),
  downloadSquareYellow: () => import("./index96.mjs"),
  dropbox: () => import("./index97.mjs"),
  emptyClipboardBlue: () => import("./index98.mjs"),
  emptyClipboardPink: () => import("./index99.mjs"),
  emptyClipboardYellow: () => import("./index100.mjs"),
  erlenmeyerFlaskBlue: () => import("./index101.mjs"),
  erlenmeyerFlaskPink: () => import("./index102.mjs"),
  erlenmeyerFlaskYellow: () => import("./index103.mjs"),
  error: () => import("./index104.mjs"),
  expandHorizontal: () => import("./index105.mjs"),
  expandVertical: () => import("./index106.mjs"),
  facebook: () => import("./index107.mjs"),
  favorite: () => import("./index108.mjs"),
  favoriteFilled: () => import("./index109.mjs"),
  fileDouble: () => import("./index110.mjs"),
  filter: () => import("./index111.mjs"),
  filterImage: () => import("./index112.mjs"),
  filterMusic: () => import("./index113.mjs"),
  filterPlus: () => import("./index114.mjs"),
  filterVideo: () => import("./index115.mjs"),
  folderStar: () => import("./index116.mjs"),
  gitHub: () => import("./index117.mjs"),
  googlePay: () => import("./index118.mjs"),
  graphPieChartBlue: () => import("./index119.mjs"),
  graphPieChartPink: () => import("./index120.mjs"),
  graphPieChartYellow: () => import("./index121.mjs"),
  gridRulesBlue: () => import("./index122.mjs"),
  gridRulesPink: () => import("./index123.mjs"),
  gridRulesYellow: () => import("./index124.mjs"),
  happyFaceBlue: () => import("./index125.mjs"),
  happyFacePink: () => import("./index126.mjs"),
  happyFaceYellow: () => import("./index127.mjs"),
  headphonesCustomer: () => import("./index128.mjs"),
  helpChatBlue: () => import("./index129.mjs"),
  helpChatPink: () => import("./index130.mjs"),
  helpChatYellow: () => import("./index131.mjs"),
  homeBlue: () => import("./index132.mjs"),
  homePink: () => import("./index133.mjs"),
  homeYellow: () => import("./index134.mjs"),
  hourGlassBlue: () => import("./index135.mjs"),
  hourGlassPink: () => import("./index136.mjs"),
  hourGlassYellow: () => import("./index137.mjs"),
  house: () => import("./index138.mjs"),
  imageModified: () => import("./index139.mjs"),
  informationCircle: () => import("./index140.mjs"),
  informationCircleInverted: () => import("./index141.mjs"),
  instagram: () => import("./index142.mjs"),
  interfaceAlertAlarmBellBlue: () => import("./index143.mjs"),
  interfaceAlertAlarmBellPink: () => import("./index144.mjs"),
  interfaceAlertAlarmBellYellow: () => import("./index145.mjs"),
  interfaceAwardTrophyBlue: () => import("./index146.mjs"),
  interfaceAwardTrophyPink: () => import("./index147.mjs"),
  interfaceAwardTrophyYellow: () => import("./index148.mjs"),
  interfaceCursorArrowBlue: () => import("./index149.mjs"),
  interfaceCursorArrowPink: () => import("./index150.mjs"),
  interfaceCursorArrowYellow: () => import("./index151.mjs"),
  interfaceFavoriteLikeBlue: () => import("./index152.mjs"),
  interfaceFavoriteLikePink: () => import("./index153.mjs"),
  interfaceFavoriteLikeYellow: () => import("./index154.mjs"),
  interfaceImageVideoAudioSubtitlesBlue: () => import("./index155.mjs"),
  interfaceImageVideoAudioSubtitlesPink: () => import("./index156.mjs"),
  interfaceImageVideoAudioSubtitlesYellow: () => import("./index157.mjs"),
  interfaceLightingLightBulbBlue: () => import("./index158.mjs"),
  interfaceLightingLightBulbPink: () => import("./index159.mjs"),
  interfaceLightingLightBulbYellow: () => import("./index160.mjs"),
  interfaceSearchBlue: () => import("./index161.mjs"),
  interfaceSearchPink: () => import("./index162.mjs"),
  interfaceSearchYellow: () => import("./index163.mjs"),
  keyboardBlue: () => import("./index164.mjs"),
  keyboardPink: () => import("./index165.mjs"),
  keyboardYellow: () => import("./index166.mjs"),
  keyboardArrowRight: () => import("./index167.mjs"),
  layersBlue: () => import("./index168.mjs"),
  layersPink: () => import("./index169.mjs"),
  layersYellow: () => import("./index170.mjs"),
  layoutWindowBlue: () => import("./index171.mjs"),
  layoutWindowPink: () => import("./index172.mjs"),
  layoutWindowYellow: () => import("./index173.mjs"),
  linkedIn: () => import("./index174.mjs"),
  lock: () => import("./index175.mjs"),
  lockUnlock: () => import("./index176.mjs"),
  loginBlue: () => import("./index177.mjs"),
  loginPink: () => import("./index178.mjs"),
  loginYellow: () => import("./index179.mjs"),
  logoStoryblocks: () => import("./index180.mjs"),
  logoStoryblocksGray: () => import("./index181.mjs"),
  logoStoryblocksWhite: () => import("./index182.mjs"),
  maestro: () => import("./index183.mjs"),
  magicWandBlue: () => import("./index184.mjs"),
  magicWandPink: () => import("./index185.mjs"),
  magicWandYellow: () => import("./index186.mjs"),
  maker: () => import("./index187.mjs"),
  mastercard: () => import("./index188.mjs"),
  megaphoneBlue: () => import("./index189.mjs"),
  megaphonePink: () => import("./index190.mjs"),
  megaphoneYellow: () => import("./index191.mjs"),
  microphone: () => import("./index192.mjs"),
  microphoneOff: () => import("./index193.mjs"),
  moneyCashBillBlue: () => import("./index194.mjs"),
  moneyCashBillPink: () => import("./index195.mjs"),
  moneyCashBillYellow: () => import("./index196.mjs"),
  moneyWalletBlue: () => import("./index197.mjs"),
  moneyWalletPink: () => import("./index198.mjs"),
  moneyWalletYellow: () => import("./index199.mjs"),
  musicSound: () => import("./index200.mjs"),
  navigationMenuHorizontal: () => import("./index201.mjs"),
  navigationMenuVertical: () => import("./index202.mjs"),
  newStickyNoteBlue: () => import("./index203.mjs"),
  newStickyNotePink: () => import("./index204.mjs"),
  newStickyNoteYellow: () => import("./index205.mjs"),
  oneFingerTapBlue: () => import("./index206.mjs"),
  oneFingerTapPink: () => import("./index207.mjs"),
  oneFingerTapYellow: () => import("./index208.mjs"),
  openBookBlue: () => import("./index209.mjs"),
  openBookPink: () => import("./index210.mjs"),
  openBookYellow: () => import("./index211.mjs"),
  panelCollapse: () => import("./index212.mjs"),
  panelExpand: () => import("./index213.mjs"),
  paragraphLeftAlign: () => import("./index214.mjs"),
  paragraphsCenterAlign: () => import("./index215.mjs"),
  paragraphsRightAlign: () => import("./index216.mjs"),
  payPal: () => import("./index217.mjs"),
  penBlue: () => import("./index218.mjs"),
  penPink: () => import("./index219.mjs"),
  penYellow: () => import("./index220.mjs"),
  pencil: () => import("./index221.mjs"),
  picturesFolderMemoriesBlue: () => import("./index222.mjs"),
  picturesFolderMemoriesPink: () => import("./index223.mjs"),
  picturesFolderMemoriesYellow: () => import("./index224.mjs"),
  pinBlue: () => import("./index225.mjs"),
  pinPink: () => import("./index226.mjs"),
  pinYellow: () => import("./index227.mjs"),
  pinterest: () => import("./index228.mjs"),
  playListBlue: () => import("./index229.mjs"),
  playListPink: () => import("./index230.mjs"),
  playListYellow: () => import("./index231.mjs"),
  playVideo: () => import("./index232.mjs"),
  plus: () => import("./index233.mjs"),
  profileAvatar: () => import("./index234.mjs"),
  questionmark: () => import("./index235.mjs"),
  refresh: () => import("./index236.mjs"),
  screenTvBlue: () => import("./index237.mjs"),
  screenTvPink: () => import("./index238.mjs"),
  screenTvYellow: () => import("./index239.mjs"),
  scriptBlue: () => import("./index240.mjs"),
  scriptPink: () => import("./index241.mjs"),
  scriptYellow: () => import("./index242.mjs"),
  search: () => import("./index243.mjs"),
  searchSimilar: () => import("./index244.mjs"),
  settingMenu: () => import("./index245.mjs"),
  share: () => import("./index246.mjs"),
  shoppingCartBlue: () => import("./index247.mjs"),
  shoppingCartPink: () => import("./index248.mjs"),
  shoppingCartYellow: () => import("./index249.mjs"),
  snapchat: () => import("./index250.mjs"),
  sparkle: () => import("./index251.mjs"),
  sparkles: () => import("./index252.mjs"),
  stamp: () => import("./index253.mjs"),
  starFourSided: () => import("./index254.mjs"),
  stopwatchBlue: () => import("./index255.mjs"),
  stopwatchPink: () => import("./index256.mjs"),
  stopwatchYellow: () => import("./index257.mjs"),
  stripe: () => import("./index258.mjs"),
  sunCloudBlue: () => import("./index259.mjs"),
  sunCloudPink: () => import("./index260.mjs"),
  sunCloudYellow: () => import("./index261.mjs"),
  textBold: () => import("./index262.mjs"),
  textInputArea: () => import("./index263.mjs"),
  textItalic: () => import("./index264.mjs"),
  textStrikeThrough: () => import("./index265.mjs"),
  textStyle: () => import("./index266.mjs"),
  textUnderline: () => import("./index267.mjs"),
  thirdEye: () => import("./index268.mjs"),
  trash: () => import("./index269.mjs"),
  travelMapEarthBlue: () => import("./index270.mjs"),
  travelMapEarthPink: () => import("./index271.mjs"),
  travelMapEarthYellow: () => import("./index272.mjs"),
  twitter: () => import("./index273.mjs"),
  uploadBottom: () => import("./index274.mjs"),
  uploadCircleBlue: () => import("./index275.mjs"),
  uploadCirclePink: () => import("./index276.mjs"),
  uploadCircleYellow: () => import("./index277.mjs"),
  userCircleSingleBlue: () => import("./index278.mjs"),
  userCircleSinglePink: () => import("./index279.mjs"),
  userCircleSingleYellow: () => import("./index280.mjs"),
  userSingleBlue: () => import("./index281.mjs"),
  userSinglePink: () => import("./index282.mjs"),
  userSingleYellow: () => import("./index283.mjs"),
  venmo: () => import("./index284.mjs"),
  verticalSliderSquareBlue: () => import("./index285.mjs"),
  verticalSliderSquarePink: () => import("./index286.mjs"),
  verticalSliderSquareYellow: () => import("./index287.mjs"),
  videoEditPeel: () => import("./index288.mjs"),
  videoEditSplit: () => import("./index289.mjs"),
  videoModified: () => import("./index290.mjs"),
  view: () => import("./index291.mjs"),
  viewOff: () => import("./index292.mjs"),
  visa: () => import("./index293.mjs"),
  voiceMailBlue: () => import("./index294.mjs"),
  voiceMailPink: () => import("./index295.mjs"),
  voiceMailYellow: () => import("./index296.mjs"),
  volumeDown: () => import("./index297.mjs"),
  volumeLevelHighBlue: () => import("./index298.mjs"),
  volumeLevelHighPink: () => import("./index299.mjs"),
  volumeLevelHighYellow: () => import("./index300.mjs"),
  volumeMedium: () => import("./index301.mjs"),
  volumeOff: () => import("./index302.mjs"),
  volumeUp: () => import("./index303.mjs"),
  warningTriangle: () => import("./index304.mjs"),
  webcamVideoBlue: () => import("./index305.mjs"),
  webcamVideoPink: () => import("./index306.mjs"),
  webcamVideoYellow: () => import("./index307.mjs"),
  youtube: () => import("./index308.mjs"),
  zap: () => import("./index309.mjs")
}, t = /* @__PURE__ */ new Set([
  "arrowCursor",
  "blankCalendar",
  "businessStartup",
  "camera",
  "cameraVideo",
  "chatBubbleTypingOval",
  "chatTwoBubblesSquare",
  "circleClock",
  "dashboardGauge",
  "downloadSquare",
  "emptyClipboard",
  "erlenmeyerFlask",
  "graphPieChart",
  "gridRules",
  "happyFace",
  "helpChat",
  "home",
  "hourGlass",
  "interfaceAlertAlarmBell",
  "interfaceAwardTrophy",
  "interfaceCursorArrow",
  "interfaceFavoriteLike",
  "interfaceImageVideoAudioSubtitles",
  "interfaceLightingLightBulb",
  "interfaceSearch",
  "keyboard",
  "layers",
  "layoutWindow",
  "login",
  "magicWand",
  "megaphone",
  "moneyCashBill",
  "moneyWallet",
  "newStickyNote",
  "oneFingerTap",
  "openBook",
  "pen",
  "picturesFolderMemories",
  "pin",
  "playList",
  "screenTv",
  "script",
  "shoppingCart",
  "stopwatch",
  "sunCloud",
  "travelMapEarth",
  "uploadCircle",
  "userCircleSingle",
  "userSingle",
  "verticalSliderSquare",
  "voiceMail",
  "volumeLevelHigh",
  "webcamVideo"
]), p = {
  arrowCursor: ["blue", "pink", "yellow"],
  blankCalendar: ["blue", "pink", "yellow"],
  businessStartup: ["blue", "pink", "yellow"],
  camera: ["blue", "pink", "yellow"],
  cameraVideo: ["blue", "pink", "yellow"],
  chatBubbleTypingOval: ["blue", "pink", "yellow"],
  chatTwoBubblesSquare: ["blue", "pink", "yellow"],
  circleClock: ["blue", "pink", "yellow"],
  dashboardGauge: ["blue", "pink", "yellow"],
  downloadSquare: ["blue", "pink", "yellow"],
  emptyClipboard: ["blue", "pink", "yellow"],
  erlenmeyerFlask: ["blue", "pink", "yellow"],
  graphPieChart: ["blue", "pink", "yellow"],
  gridRules: ["blue", "pink", "yellow"],
  happyFace: ["blue", "pink", "yellow"],
  helpChat: ["blue", "pink", "yellow"],
  home: ["blue", "pink", "yellow"],
  hourGlass: ["blue", "pink", "yellow"],
  interfaceAlertAlarmBell: ["blue", "pink", "yellow"],
  interfaceAwardTrophy: ["blue", "pink", "yellow"],
  interfaceCursorArrow: ["blue", "pink", "yellow"],
  interfaceFavoriteLike: ["blue", "pink", "yellow"],
  interfaceImageVideoAudioSubtitles: ["blue", "pink", "yellow"],
  interfaceLightingLightBulb: ["blue", "pink", "yellow"],
  interfaceSearch: ["blue", "pink", "yellow"],
  keyboard: ["blue", "pink", "yellow"],
  layers: ["blue", "pink", "yellow"],
  layoutWindow: ["blue", "pink", "yellow"],
  login: ["blue", "pink", "yellow"],
  magicWand: ["blue", "pink", "yellow"],
  megaphone: ["blue", "pink", "yellow"],
  moneyCashBill: ["blue", "pink", "yellow"],
  moneyWallet: ["blue", "pink", "yellow"],
  newStickyNote: ["blue", "pink", "yellow"],
  oneFingerTap: ["blue", "pink", "yellow"],
  openBook: ["blue", "pink", "yellow"],
  pen: ["blue", "pink", "yellow"],
  picturesFolderMemories: ["blue", "pink", "yellow"],
  pin: ["blue", "pink", "yellow"],
  playList: ["blue", "pink", "yellow"],
  screenTv: ["blue", "pink", "yellow"],
  script: ["blue", "pink", "yellow"],
  shoppingCart: ["blue", "pink", "yellow"],
  stopwatch: ["blue", "pink", "yellow"],
  sunCloud: ["blue", "pink", "yellow"],
  travelMapEarth: ["blue", "pink", "yellow"],
  uploadCircle: ["blue", "pink", "yellow"],
  userCircleSingle: ["blue", "pink", "yellow"],
  userSingle: ["blue", "pink", "yellow"],
  verticalSliderSquare: ["blue", "pink", "yellow"],
  voiceMail: ["blue", "pink", "yellow"],
  volumeLevelHigh: ["blue", "pink", "yellow"],
  webcamVideo: ["blue", "pink", "yellow"]
};
function m(e, o) {
  let r = e;
  if (t.has(e)) {
    const i = p[e] || [], l = o || i[0];
    if (o && !i.includes(o))
      return console.error(
        'Invalid variant "' + o + '" for icon "' + e + '". Available variants: ' + i.join(", ")
      ), null;
    r = e + l.charAt(0).toUpperCase() + l.slice(1);
  } else o && console.warn('Icon "' + e + '" does not support variants. Ignoring variant "' + o + '".');
  return a[r] || null;
}
function n(e) {
  return t.has(e);
}
function u(e) {
  const o = p[e];
  return o ? o[0] : void 0;
}
export {
  u as getDefaultVariant,
  m as getIconImport,
  n as hasVariants
};
